import SalesReferralLeadList from './SalesReferralLeadList';

export default SalesReferralLeadList;

